export default {
  imgs: [
    {
      name: "加载背景",
      src: require(`@img/root/loading_bg.jpg`),
    },
    {
      name: "背景",
      src: require(`@img/root/default_bg.jpg`),
    },
    {
      name: "喂养按钮",
      src: require(`@img/root/btn-style_1.png`),
    },
    {
      name: "采集按钮",
      src: require(`@img/root/btn-harvest.png`),
    },
    {
      name: "采集装饰-left",
      src: require(`@img/root/harvest-left.png`),
    },
    {
      name: "采集装饰-right",
      src: require(`@img/root/harvest-right.png`),
    },
    {
      name: "头像边框",
      src: require(`@img/root/avatar-border.png`),
    },
    {
      name: "水晶矿数量背景",
      src: require(`@img/root/coin_bg.png`),
    },
    {
      name: "用户名背景",
      src: require(`@img/root/name_bg.png`),
    },
    {
      name: "水晶矿进度背景",
      src: require(`@img/root/coin-bar_bg.png`),
    },
    {
      name: "水晶矿进度条",
      src: require(`@img/root/coin-bar_solid.png`),
    },
    {
      name: "水晶信息弹窗背景",
      src: require("@img/root/pop-coin_info_bg.png"),
    },
    {
      name: "水晶信息弹窗经验外框",
      src: require("@img/root/pop-coin_info_bar_border.png"),
    },
    {
      name: "水晶信息弹窗经验条",
      src: require("@img/root/pop-coin_info_bar_solid.png"),
    },
    {
      name: "场景",
      src: require("@img/root/main-bg.jpg"),
    },
    {
      name: "场景地面",
      src: require("@img/root/main-table.png"),
    },
    {
      name: "场景前景",
      src: require("@img/root/main-front.png"),
    },
    {
      name: "怪兽信息板",
      src: require("@img/root/pet-info_block.png"),
    },
    {
      name: "怪兽光圈1",
      src: require("@img/root/pet-effect_base_1.png"),
    },
    {
      name: "怪兽光圈2",
      src: require("@img/root/pet-effect_base_2.png"),
    },
    {
      name: "怪兽光圈3",
      src: require("@img/root/pet-effect_base_3.png"),
    },
    {
      name: "怪兽光圈4",
      src: require("@img/root/pet-effect_base_4.png"),
    },
    {
      name: "发散光",
      src: require("@img/root/light.png"),
    },
    {
      name: "怪兽名字背景",
      src: require("@img/root/pet-name_bg.png"),
    },
    {
      name: "怪兽信息板",
      src: require("@img/root/pet-intr_block.png"),
    },
    {
      name: "音乐控制背景",
      src: require("@img/root/sound-handler_bg.png"),
    },
    {
      name: "音乐控制展示",
      src: require("@img/root/sound-handler_open.png"),
    },
    {
      name: "音乐控制隐藏",
      src: require("@img/root/sound-handler_close.png"),
    },
  ],
  sounds: [
    // {
    //   name: "喂食",
    //   id: "feed",
    //   src: require("@/assets/audio/feed.mp3"),
    // },
    // {
    //   name: "收集水晶",
    //   id: "collectCrystal",
    //   src: require("@/assets/audio/coin.mp3"),
    // },
  ],
};
